import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import ActionsModal from 'components/ActionsModal'

import {
  selectDisplayedOrganization,
  updateDisplayedOrganization,
  closeDisplayedOrganization,
} from 'store/organizations'

import { selectOrganizations } from 'store/global'
import messages from './messages'

export default function EditOrganizationModal({ onSubmit }) {
  const dispatch = useDispatch()

  const allOrganizations = useSelector(selectOrganizations)
  const displayedOrganization = useSelector(selectDisplayedOrganization)

  const onFieldChange = (key, value) => dispatch(updateDisplayedOrganization({ key, value }))

  const onCloseModal = () => dispatch(closeDisplayedOrganization())

  const isOrganizationNameAvailable = name => 
    allOrganizations.every(organization => 
      organization.name !== name || organization.id === displayedOrganization.id
    )

  const fields = {
    name: {
      key: 'name',
      isRequired: true,
      label: <FormattedMessage {...messages.labels.name} />,
      validator: isOrganizationNameAvailable,
      formFeedback: <FormattedMessage {...messages.formFeedback.nameUnavailable} />,
    }
  }

  return (
    <ActionsModal
      type='organization'
      mode='edit'
      item={displayedOrganization}
      primaryKey='name'
      fields={fields}
      onFieldChange={onFieldChange}
      onClose={onCloseModal}
      onSubmit={() => onSubmit(displayedOrganization)}
    />
  )
}

EditOrganizationModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
} 